import { Model } from 'vue-mc'
import { Request } from '@/http'

import _ from 'lodash'

class GenericModel extends Model {
    getRequest(config) {
        return new Request(config)
    }

    cancelChanges() {
        let changes = this.changed()

        if (!changes) return

        changes.forEach(attrib => {
            this.attributes[attrib] = this.$[attrib]
        })
    }

    onSaveSuccess(response) {
        // let message = _.get(
        //     response,
        //     'response.response.data.message',
        //     'Operation successful'
        // )
        // EventBus.$emit('model.save-success', message)
        super.onSaveSuccess(response)
    }

    onSaveFailure(error) {
        let message = _.get(
            error,
            'error.response.data.message',
            'Operation failed'
        )
        // EventBus.$emit('model.save-failure', message)
        return super.onSaveFailure(message)
    }

    onDeleteSuccess(response) {
        // let message = _.get(
        //     response,
        //     'response.response.data.message',
        //     'Operation successful'
        // )
        // EventBus.$emit('model.delete-success', message)
        return super.onDeleteSuccess(response)
    }

    onDeleteFailure(error) {
        // let message = _.get(
        //     error,
        //     'error.response.data.message',
        //     'Operation failed'
        // )
        // EventBus.$emit('model.delete-failure', message)
        return super.onDeleteFailure(error)
    }

    request(config, onRequest, onSuccess, onFailure) {
        return super.request(config, onRequest, onSuccess, onFailure)
    }

    options() {
        return {
            methods: {
                fetch: 'GET',
                save: 'POST',
                update: 'PUT',
                create: 'POST',
                patch: 'PATCH',
                delete: 'DELETE',
            },
        }
    }

    shouldPatch() {
        return true
    }

    setResourceName(name) {
        this.resourceName = name
        return this
    }

    getResourceName() {
        if (typeof this.resourceName == 'undefined') {
            console.warn('Guessing resourcename! Should be set.')
            return this.constructor.name.toLowerCase()
        }

        if (typeof this.resourceName == 'function') {
            return this.resourceName()
        }

        return this.resourceName
    }

    getPrimaryKey() {
        return this.attributes.id
    }

    setFields(fields) {
        this.setOption('query.fields', fields)
        return this
    }

    getFetchQuery() {
        return this.getOption('query')
    }

    setIncludes(include) {
        this.setOption('query.include', include)
        return this
    }

    createRoute() {
        return '/resource/' + this.getResourceName() + '/'
    }

    routes() {
        return {
            fetch: this.createRoute() + '{id}',
            patch: this.createRoute() + this.getPrimaryKey(),
            delete: this.createRoute() + this.getPrimaryKey(),
            save: this.createRoute(),
            create: this.createRoute(),
        }
    }
}

export default GenericModel
